import React from "react"

import Bowser from "bowser"
import { Main } from "../../styles/Container"

const browser =
  typeof window !== "undefined" && Bowser.getParser(window.navigator.userAgent)

export default function BrowserNotSupported() {
  return (
    <Main style={{ flexDirection: "column", justifyContent: "flex-start" }}>
      <h2 style={{ margin: "3rem" }}>Vi støtter ikke nettleseren din</h2>

      <br />
      {browser && browser.getBrowser().name === "Internet Explorer" ? (
        <p>
          Denne appen støtter ingen versjoner av Internet Explorer. Se{" "}
          <a href="https://browsehappy.com/?locale=nb_NO">Surf Lykkelig</a> for
          forslag til moderne nettlesere.
        </p>
      ) : (
        <p>
          Vennligst oppgrader til en nyere versjon eller{" "}
          <a href="https://browsehappy.com/?locale=nb_NO">velg en annen</a>. Det
          forbedrer også sikkerheten.
        </p>
      )}
    </Main>
  )
}
